import { api } from '../../../common/api/httpClient';
import type {
  DraftConversionResult,
  PageResult,
  PortalDraftDetail,
  PortalDraftListItem,
  TenantApplication,
  TenantApplicationDraftResult,
  TenantApplicationValues,
} from '../model/drafts';

export const DRAFTS_PAGE_SIZE = 10;

export type DraftListQuery = {
  keyword?: string;
  page?: number;
  pageSize?: number;
};

function query(path: string, values: Record<string, unknown>) {
  const params = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, String(value));
    }
  });
  const suffix = params.toString();
  return suffix ? `${path}?${suffix}` : path;
}

function json(method: string, body?: unknown): RequestInit {
  return {
    method,
    body: body === undefined ? undefined : JSON.stringify(body),
  };
}

export function draftListPath(values: DraftListQuery) {
  return query('/api/portal/drafts', {
    ...values,
    sort: 'lastSavedAt_desc',
  });
}

export const draftsApi = {
  list(values: DraftListQuery) {
    return api<PageResult<PortalDraftListItem>>(
      draftListPath(values));
  },
  detail(draftPublicId: string, options: Readonly<{ signal?: AbortSignal }> = {}) {
    return api<PortalDraftDetail>(
      `/api/portal/drafts/${draftPublicId}`, { signal: options.signal });
  },
  delete(draftPublicId: string, expectedDraftVersion: number) {
    return api<void>(
      `/api/portal/drafts/${draftPublicId}`,
      json('DELETE', { expectedDraftVersion }));
  },
  execute(
    draftPublicId: string,
    body: {
      actionCode: string;
      expectedDraftVersion: number;
      operationId: string;
    },
    options: Readonly<{ signal?: AbortSignal }> = {},
  ) {
    return api<DraftConversionResult>(
      `/api/portal/drafts/${draftPublicId}/actions`,
      { ...json('POST', body), signal: options.signal });
  },
  tenantApplication(applicationPublicId: string) {
    return api<TenantApplication>(
      `/api/admin/tenant-applications/${applicationPublicId}`);
  },
  saveTenantApplicationDraft(
    draftPublicId: string,
    application: TenantApplication,
    expectedDraftVersion: number,
    values: TenantApplicationValues,
    operationId: string,
  ) {
    return api<TenantApplicationDraftResult>(
      `/api/admin/tenant-applications/drafts/${draftPublicId}`,
      json('PUT', {
        ...values,
        version: application.version,
        expectedDraftVersion,
        operationId,
      }));
  },
};
